/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import Decimal from "decimal.js-light";

export default Decimal;
